import React, { useEffect, useState } from 'react';
import {
  Box,
  Card,
  CardHeader,
  Chip,
  Container,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  makeStyles
} from '@material-ui/core';
import PerfectScrollbar from 'react-perfect-scrollbar';
import toast from 'react-hot-toast';
import Page from 'src/components/Page';
import Broadcast from 'src/api/broadcast';

const AUDIENCE_LABELS = {
  all_riders: 'All Riders',
  all_drivers: 'All Drivers',
  both: 'Both (All Users)'
};

const STATUS_COLORS = {
  Completed: 'primary',
  Sending: 'default',
  Queued: 'default',
  Failed: 'secondary'
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const formatDate = value => {
  if (!value) return '—';
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? '—' : d.toLocaleString();
};

const BroadcastHistory = () => {
  const classes = useStyles();
  const [broadcasts, setBroadcasts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    Broadcast.getHistory()
      .then(res => {
        if (active) setBroadcasts(res.data.data || []);
      })
      .catch(err => {
        // Interceptor already toasted network errors (ISSUE-0201).
        if (err.response) {
          toast.error(
            err.response.data?.errors?.[0] || 'Failed to load broadcasts'
          );
        }
        if (active) setBroadcasts([]);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <Page className={classes.root} title="Broadcast History">
      <Container maxWidth={false}>
        <Card>
          <CardHeader
            title="Broadcast History"
            subheader="The 20 most recent broadcasts"
          />
          <Divider />
          <PerfectScrollbar>
            <Box minWidth={800}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Subject</TableCell>
                    <TableCell>Audience</TableCell>
                    <TableCell>Recipients</TableCell>
                    <TableCell>Sent</TableCell>
                    <TableCell>Failed</TableCell>
                    <TableCell>Status</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {broadcasts.map(b => (
                    <TableRow hover key={b.id}>
                      <TableCell>{formatDate(b.createdAt)}</TableCell>
                      <TableCell>{b.subject}</TableCell>
                      <TableCell>
                        {AUDIENCE_LABELS[b.audience] || b.audience}
                      </TableCell>
                      <TableCell>{b.totalRecipients}</TableCell>
                      <TableCell>{b.sentCount}</TableCell>
                      <TableCell>{b.failedCount}</TableCell>
                      <TableCell>
                        <Chip
                          size="small"
                          color={STATUS_COLORS[b.status] || 'default'}
                          label={b.status}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
              {!loading && broadcasts.length === 0 && (
                <Box p={3}>
                  <Typography align="center" color="textSecondary">
                    No broadcasts sent yet.
                  </Typography>
                </Box>
              )}
            </Box>
          </PerfectScrollbar>
        </Card>
      </Container>
    </Page>
  );
};

export default BroadcastHistory;
